import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppTitleService } from '@services/title.service';

import { AuthApiService } from '@auth/services/auth-api.service';
import { TokenService } from '@services/token.service';

@Component({
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit, OnDestroy {
    remaining_time;
    timer;
    constructor(
        private authApiService: AuthApiService,
        private tokenService: TokenService,
        private titleService: AppTitleService
    ) {}

    ngOnInit() {
        this.handleStart();
        this.titleService.setTitle('Portal');
    }

    ngOnDestroy() {
        this.handleStop();
    }

    logoutUser() {
        this.authApiService.logout();
    }

    // timer functions

    async handleStart() {
        const expirationTime = this.tokenService.expirationTime;
        this.remaining_time = expirationTime - new Date().getTime();

        this.timer = setInterval(async () => {
            this.remaining_time = this.remaining_time - 1000;
            if (this.remaining_time <= 60000) {
                this.handleStop();
                this.authApiService.refresh_token().subscribe(
                    res => {
                        this.handleRestart();
                    },
                    err => {
                        console.log(err);
                        alert(err['error']['non_field_error']);
                        this.handleFullStop();
                    }
                );
            }
        }, 1000);
    }

    handleStop() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    handleFullStop() {
        this.handleStop();
        this.authApiService.logout();
    }

    async handleRestart() {
        this.handleStop();
        await this.handleStart();
    }
}
